<template>
  <modal
    ref="modal"
    title=""
    class="primary link-preview-modal rs-modern-modal"
    size="modal-dialog modal-dialog-centered modal-dialog-scrollable link-preview-dialog"
  >
    <template #header>
      <div class="rs-modal-header">
        <div class="rs-modal-header-left">
          <div class="rs-modal-header-icon">
            <svg width="34" height="34" viewBox="0 0 24 24" fill="none">
              <path
                d="M9.99996 13C10.4294 13.5741 10.9773 14.0492 11.6065 14.3929C12.2357 14.7367 12.9315 14.9411 13.6466 14.9923C14.3617 15.0436 15.0795 14.9404 15.7513 14.6898C16.4231 14.4392 17.0331 14.0471 17.54 13.54L20.54 10.54C21.4507 9.59699 21.9547 8.33398 21.9433 7.023C21.9319 5.71201 21.4061 4.45795 20.479 3.53091C19.552 2.60387 18.2979 2.07803 16.987 2.06663C15.676 2.05524 14.413 2.55921 13.47 3.47L11.75 5.18M14 11C13.5705 10.4259 13.0226 9.95082 12.3934 9.60706C11.7642 9.26331 11.0684 9.05889 10.3533 9.00767C9.63816 8.95645 8.92037 9.05964 8.24861 9.31022C7.57685 9.56081 6.96684 9.95293 6.45996 10.46L3.45996 13.46C2.54917 14.403 2.04519 15.666 2.05659 16.977C2.06798 18.288 2.59382 19.5421 3.52086 20.4691C4.4479 21.3961 5.70197 21.922 7.01295 21.9334C8.32393 21.9448 9.58694 21.4408 10.53 20.53L12.24 18.82"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>

          <div>
            <h1>{{ by.title || "Konu videosu" }}</h1>
            <p>Video uygulama içindeki güvenli önizleme alanında gösteriliyor.</p>
          </div>
        </div>

        <a href="javascript:void(0)" class="rs-modal-close" @click="ok">
          <i class="icon icon-xmark"></i>
        </a>
      </div>
    </template>

    <div class="link-preview-body">
      <div class="link-preview-top" v-if="by.linkList.length > 1">
        <span>{{ by.currentIndex + 1 }} / {{ by.linkList.length }}</span>
      </div>

      <div class="link-preview-card">
        <template v-if="currentLink && isYouTube(currentLink)">
          <div class="link-video-wrap">
            <iframe
                :src="getYouTubeEmbed(currentLink)"
                frameborder="0"
                allowfullscreen
                class="link-preview-frame"
            ></iframe>
          </div>
        </template>

        <template v-else-if="currentLink">
          <div class="link-preview-action">
            <a :href="currentLink" target="_blank" rel="noopener noreferrer" class="link-open-btn">
              Videoyu aç
              <span>↗</span>
            </a>
          </div>

          <iframe
            :src="currentLink"
            class="link-preview-frame"
          ></iframe>
        </template>

        <div v-else class="link-preview-empty">
          <h3>Bağlantı bulunamadı</h3>
          <p>Bu konu için henüz görüntülenebilir bir kaynak eklenmemiş.</p>
        </div>
      </div>
    </div>

    <template #footer>
      <div class="rs-modal-footer link-preview-footer">
        <button
        v-if="by.currentIndex > 0"
        @click="prevSlide"
        class="rs-modal-secondary-btn"
        >
        <i class="icon icon-chevron-left"></i>
        <span>Önceki</span>
        </button>

        <div v-else></div>

        <button class="rs-modal-primary-btn" @click="ok">
          Kapat
        </button>

        <button
        v-if="by.currentIndex + 1 < by.linkList.length"
        @click="nextSlide"
        class="rs-modal-secondary-btn"
        >
        <span>Sonraki</span>
        <i class="icon icon-chevron-right"></i>
        </button>

        <div v-else></div>
      </div>
    </template>
  </modal>
</template>

<script>
import { reactive, toRefs, computed } from "vue";

export default {
  name: "LinkPreview",
  emits: ["change"],

  setup(props, ctx) {
    const e = reactive({
      modal: null,

      by: {
        currentIndex: 0,
        linkList: [],
        title: "",
      },

      open(event) {
        e.by = {
          currentIndex: 0,
          linkList: event.list || [],
          title: event.title || "",
        };

        if (e.by.linkList.length > 0) {
          e.modal.show();
        }
      },

      ok() {
        e.modal.hide();
        e.by.currentIndex = -1;
        ctx.emit("change", {});
      },

      isValidLink(link) {
        const pattern = /^(http|https):\/\/[^ "]+$/;
        return pattern.test(link);
      },

      isYouTube(link) {
        if (!link) return false;
        return link.includes("youtube.com") || link.includes("youtu.be");
      },

      isPlaylist(link) {
        if (!link) return false;
        return link.includes("playlist?list=");
      },

      getYouTubeEmbed(link) {
        let embedUrl = "";

        try {
          if (e.isPlaylist(link)) {
            const playlistId = new URL(link).searchParams.get("list");
            embedUrl = `https://www.youtube.com/embed/videoseries?list=${playlistId}`;
          } else if (link.includes("youtube.com")) {
            const videoId = new URL(link).searchParams.get("v");
            embedUrl = `https://www.youtube.com/embed/${videoId}`;
          } else if (link.includes("youtu.be")) {
            const videoId = link.split("/").pop();
            embedUrl = `https://www.youtube.com/embed/${videoId}`;
          }
        } catch {
          embedUrl = link;
        }

        return embedUrl;
      },

      currentLink: computed(() => {
        return e.by.linkList[e.by.currentIndex] || "";
      }),

      prevSlide() {
        if (e.by.currentIndex > 0) {
          e.by.currentIndex--;
        }
      },

      nextSlide() {
        if (e.by.currentIndex + 1 < e.by.linkList.length) {
          e.by.currentIndex++;
        }
      },
    });

    return { ...toRefs(e) };
  },
};
</script>

<style scoped>
.rs-modern-modal :deep(.modal-content) {
  border: 0;
  border-radius: 22px;
  overflow: hidden;
  box-shadow: 0 24px 80px rgba(20, 20, 35, 0.22);
}

.rs-modern-modal :deep(.modal-header) {
  padding: 0 !important;
  border-bottom: 1px solid #eef0f6;
}

.rs-modern-modal :deep(.modal-body) {
  padding: 0;
}

.rs-modern-modal :deep(.modal-footer) {
  border-top: 0;
  padding: 0 32px 32px;
}

.rs-modal-header {
  width: 100%;
  min-height: 86px;
  padding: 18px 28px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: linear-gradient(180deg, #ffffff 0%, #fbfbfe 100%);
}

.rs-modal-header-left {
  display: flex;
  align-items: center;
  gap: 16px;
}

.rs-modal-header-icon {
  width: 54px;
  height: 54px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #a45acb;
  background: rgba(164, 90, 203, 0.1);
  flex: 0 0 54px;
}

.rs-modal-header-icon svg {
  width: 30px;
  height: 30px;
}

.rs-modal-header h1 {
  margin: 0;
  font-size: 20px;
  line-height: 1.2;
  font-weight: 600;
  color: #12122b;
}

.rs-modal-header p {
  margin: 5px 0 0;
  font-size: 12px;
  line-height: 1.45;
  color: #687084;
}

.rs-modal-close {
  width: 42px;
  height: 42px;
  border-radius: 14px;
  border: 1px solid #ececf4;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #a45acb;
  background: #ffffff;
  text-decoration: none;
  transition: 0.2s ease;
  flex: 0 0 42px;
}

.rs-modal-close:hover {
  background: rgba(164, 90, 203, 0.08);
}

.rs-modal-footer {
  width: 100%;
  display: flex;
  justify-content: center;
  gap: 14px;
}

.rs-modal-primary-btn,
.rs-modal-secondary-btn {
  height: 52px;
  border-radius: 13px;
  font-size: 15px;
  font-weight: 600;
  transition: 0.2s ease;
}

.rs-modal-primary-btn {
  flex: 1;
  border: 0;
  background: linear-gradient(135deg, #8d3fc0, #b96bd4);
  color: #ffffff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  box-shadow: 0 12px 24px rgba(164, 90, 203, 0.25);
}

.rs-modal-secondary-btn {
  flex: 0.55;
  border: 1px solid #ececf4;
  color: #a45acb;
  background: #ffffff;
  box-shadow: 0 8px 18px rgba(17, 24, 39, 0.04);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.rs-modal-secondary-btn:disabled {
  opacity: 0.38;
  cursor: not-allowed;
  box-shadow: none;
}

.link-preview-body {
  padding: 28px 32px 26px;
}

.link-preview-top {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 12px;
}

.link-preview-top span {
  padding: 8px 13px;
  border-radius: 999px;
  background: rgba(164, 90, 203, 0.1);
  color: #a45acb;
  font-size: 12px;
  font-weight: 700;
}

.link-preview-card {
  border: 1px solid #e2e7f0;
  border-radius: 18px;
  overflow: hidden;
  background: #ffffff;
  box-shadow: 0 14px 38px rgba(17, 24, 39, 0.045);
}

.link-video-wrap {
  width: 100%;
  aspect-ratio: 16 / 9;
  background: #f8f9fc;
}

.link-preview-frame {
  width: 100%;
  height: 100%;
  min-height: 0;
  border: 0;
  display: block;
  background: #f8f9fc;
}

.link-preview-action {
  padding: 16px;
  border-bottom: 1px solid #eef0f6;
  display: flex;
  justify-content: flex-end;
}

.link-open-btn {
  min-width: 170px;
  height: 42px;
  border-radius: 12px;
  color: #ffffff;
  background: linear-gradient(135deg, #8d3fc0, #b96bd4);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  text-decoration: none;
  font-size: 14px;
  font-weight: 600;
}

.link-preview-empty {
  min-height: 260px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 34px;
}

.link-preview-empty h3 {
  margin: 0 0 8px;
  font-size: 20px;
  font-weight: 700;
  color: #12122b;
}

.link-preview-empty p {
  margin: 0;
  max-width: 340px;
  color: #687084;
  font-size: 13px;
  line-height: 1.5;
}

.link-preview-footer {
  display: grid;
  grid-template-columns: 0.6fr 1fr 0.6fr;
}
.link-preview-modal :deep(.modal-dialog) {
  max-width: 1180px;
}
.link-preview-modal :deep(.modal-dialog) {
  width: 90vw !important;
  max-width: 1180px !important;
}

.link-preview-modal :deep(.modal-content) {
  width: 100% !important;
}

.link-preview-body {
  padding: 24px 32px 24px;
}

.link-preview-card {
  width: 100%;
  max-width: 100%;
  margin: 0 auto;
}

.link-video-wrap {
  width: 100%;
  aspect-ratio: 16 / 9;
  background: #000;
}

.link-preview-frame {
  width: 100% !important;
  height: 100% !important;
  min-height: 0 !important;
  border: 0;
  display: block;
}
.link-preview-modal :deep(.link-preview-dialog) {
  width: 90vw !important;
  max-width: 1180px !important;
}
.link-preview-body {
  width: 100%;
}

.link-preview-card {
  width: 100%;
}

.link-video-wrap {
  width: 100%;
  aspect-ratio: 16 / 9;
}

.link-preview-frame {
  width: 100% !important;
  height: 100% !important;
}
:global(.link-preview-modal .modal-dialog) {
  width: 90vw !important;
  max-width: 1180px !important;
  margin-left: auto !important;
  margin-right: auto !important;
}

:global(.link-preview-modal .modal-content) {
  width: 100% !important;
  max-width: 100% !important;
}

:global(.link-preview-modal .link-preview-body) {
  width: 100% !important;
}

:global(.link-preview-modal .link-preview-card) {
  width: 90% !important;
  max-width: 90% !important;
  margin: 0 auto !important;
}

:global(.link-preview-modal .link-video-wrap) {
  width: 100% !important;
  aspect-ratio: 16 / 9 !important;
  background: #000;
}

:global(.link-preview-modal .link-preview-frame) {
  width: 100% !important;
  height: 100% !important;
  min-height: 0 !important;
}


@media (max-width: 767px) {
  .rs-modern-modal :deep(.modal-dialog) {
    margin: 12px;
  }

  .rs-modern-modal :deep(.modal-footer) {
    padding: 0 18px 22px;
  }

  .rs-modal-header {
    min-height: auto;
    padding: 16px;
    align-items: flex-start;
  }

  .rs-modal-header-left {
    gap: 12px;
  }

  .rs-modal-header-icon {
    width: 46px;
    height: 46px;
    border-radius: 14px;
    flex: 0 0 46px;
  }

  .rs-modal-header-icon svg {
    width: 26px;
    height: 26px;
  }

  .rs-modal-header h1 {
    font-size: 18px;
  }

  .rs-modal-header p {
    font-size: 12px;
    line-height: 1.4;
  }

  .rs-modal-close {
    width: 38px;
    height: 38px;
    border-radius: 12px;
    flex: 0 0 38px;
  }

  .link-preview-body {
    padding: 0px;
  }

  .link-preview-footer {
    grid-template-columns: 42px 1fr 42px;
    gap: 10px;
  }

  .rs-modal-primary-btn,
  .rs-modal-secondary-btn {
    width: 100%;
    min-width: 0;
    height: 48px;
    font-size: 14px;
  }

  .rs-modal-secondary-btn span {
    display: none;
  }

  .link-open-btn {
    width: 100%;
  }
  .link-preview-modal :deep(.modal-dialog) {
    width: calc(100vw - 24px) !important;
    max-width: calc(100vw - 24px) !important;
  }


  .link-video-wrap {
    aspect-ratio: 16 / 9;
  }

  .link-preview-frame {
    min-height: 0 !important;
  }
  :global(.link-preview-modal .modal-dialog) {
    width: calc(100vw - 24px) !important;
    max-width: calc(100vw - 24px) !important;
  }

  :global(.link-preview-modal .link-preview-card) {
    width: 100% !important;
    max-width: 100% !important;
  }
}
</style>
